"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleAPIError = /** @class */ (function () {
    function SimpleAPIError(data) {
        this.data = data;
    }
    /**
     * Get the message part of the error
     */
    SimpleAPIError.prototype.getMessage = function () {
        return this.data.message ? this.data.message : this.data.detail;
    };
    /**
     * Get the status code of the error if it exists.
     */
    SimpleAPIError.prototype.getStatus = function () {
        if (this.data.hasOwnProperty("status")) {
            return this.data.status;
        }
        return null;
    };
    /**
     * Get the Raw Error
     */
    SimpleAPIError.prototype.getRaw = function () {
        return this.data;
    };
    /**
     * Check to see if the error contains any meta information
     * @param field {string}
     */
    SimpleAPIError.prototype.hasMeta = function (field) {
        return (this.data.hasOwnProperty("meta") && this.data.meta.hasOwnProperty(field));
    };
    /**
     * Get a specific meta field on this error object
     * @param field {string}
     * @param fallback {any}
     */
    SimpleAPIError.prototype.getMeta = function (field, fallback) {
        if (fallback === void 0) { fallback = null; }
        /*
         * Check to see if this error has the required meta field.
         */
        if (this.hasMeta(field)) {
            return this.data.meta[field];
        }
        return fallback;
    };
    /**
     * Attempt to Convert this object to a string.
     */
    SimpleAPIError.prototype.toString = function () {
        return this.getMessage() ? this.getMessage() : this.getRaw();
    };
    return SimpleAPIError;
}());
exports.SimpleAPIError = SimpleAPIError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvQVBJL1NpbXBsZUFQSS9FcnJvcnMvU2ltcGxlQVBJRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFLQTtJQUdFLHdCQUFZLElBQTZCO1FBQ3ZDLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO0lBQ25CLENBQUM7SUFFRDs7T0FFRztJQUNJLG1DQUFVLEdBQWpCO1FBQ0UsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ2xFLENBQUM7SUFFRDs7T0FFRztJQUNJLGtDQUFTLEdBQWhCO1FBQ0UsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxRQUFRLENBQUMsRUFBRTtZQUN0QyxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO1NBQ3pCO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQ7O09BRUc7SUFDSSwrQkFBTSxHQUFiO1FBQ0UsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDO0lBQ25CLENBQUM7SUFFRDs7O09BR0c7SUFDSSxnQ0FBTyxHQUFkLFVBQWUsS0FBYTtRQUMxQixPQUFPLENBQ0wsSUFBSSxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxDQUN6RSxDQUFDO0lBQ0osQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxnQ0FBTyxHQUFkLFVBQWUsS0FBYSxFQUFFLFFBQW9CO1FBQXBCLHlCQUFBLEVBQUEsZUFBb0I7UUFDaEQ7O1dBRUc7UUFDSCxJQUFJLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUU7WUFDdkIsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztTQUM5QjtRQUVELE9BQU8sUUFBUSxDQUFDO0lBQ2xCLENBQUM7SUFFRDs7T0FFRztJQUNJLGlDQUFRLEdBQWY7UUFDRSxPQUFPLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFVBQVUsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7SUFDL0QsQ0FBQztJQUNILHFCQUFDO0FBQUQsQ0FBQyxBQS9ERCxJQStEQztBQS9EWSx3Q0FBYyJ9